<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar o biológico <b>{{this.entry.description}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(biological) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_BIOLOGICAL_MUTATION,
          variables: {
            id: biological.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyBiological.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_BIOLOGICAL_MUTATION = gql `
  mutation($id: ID!) {
    destroyBiological(id: $id) {
      item {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>